module.exports = __webpack_public_path__ + "img/02.d996d787.jpg";